"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipoDashboardToJSON = exports.TipoDashboardFromJSONTyped = exports.TipoDashboardFromJSON = exports.TipoDashboard = void 0;
/**
 *
 *
 * 0 = CampagnaOnBoarding
 *
 * 1 = CampagnaMassiva
 * @export
 * @enum {string}
 */
var TipoDashboard;
(function (TipoDashboard) {
    TipoDashboard[TipoDashboard["NUMBER_0"] = 0] = "NUMBER_0";
    TipoDashboard[TipoDashboard["NUMBER_1"] = 1] = "NUMBER_1";
})(TipoDashboard = exports.TipoDashboard || (exports.TipoDashboard = {}));
function TipoDashboardFromJSON(json) {
    return TipoDashboardFromJSONTyped(json, false);
}
exports.TipoDashboardFromJSON = TipoDashboardFromJSON;
function TipoDashboardFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TipoDashboardFromJSONTyped = TipoDashboardFromJSONTyped;
function TipoDashboardToJSON(value) {
    return value;
}
exports.TipoDashboardToJSON = TipoDashboardToJSON;
